import React from 'react'
import ReactDom from 'react-dom'
import unitmap from '@engrain/unitmap'
import { trackEvent } from '../utilities/analytics'

class UnitMapPanel extends React.Component {

  constructor(props) {
    super(props)

    this.unitmap = null
  }

  shouldComponentUpdate(nextProps, nextState) {
    return nextProps.config !== this.props.config
    || nextProps.document !== this.props.document
    || nextProps.currentFloor !== this.props.currentFloor
    || nextProps.highlightedUnit !== this.props.highlightedUnit
    || nextProps.units !== this.props.units
  }

  isFilteredUnit(event) {
    const {units} = this.props

    let target = event.hitarea.target()

    // check if the hitarea has a target
    if (target !== null) {
      // check if hitarea has an id
      if (target.id !== undefined) {
        // check if unit passes all current filters
        if (units[target.id] !== undefined) {
          return true
        }
      }
    }
    return false
  }

  componentDidMount() {
    const {
      backgroundColor,
      config,
      document,
      hilightLevel,
      highlightedUnit,
      units,
      currentFloor
    } = this.props

    this.unitmap = unitmap(this.refs.unitmap, {
        backgroundColor: backgroundColor
    })

    if (this.props.onUnitMap) {
      this.props.onUnitMap({unitmap: this.unitmap})
    }

    if (document) {
      this.unitmap.document(document.toJS())

      // get all floors
      let floors = this.unitmap.select('levels').has({
        floor: true
      })

      floors.except({
        floor: currentFloor
      }).hide()

      floors.where({
        floor: currentFloor
      }).show()

      // get all units
      let all_units = this.unitmap.select('units')

      // set all units to unavailable
      all_units.color(config.style.noCriteria)

      // change color filtered units
      all_units.find(Object.keys(units)).color(config.style.allCriteria)

      if (highlightedUnit !== null) {
        all_units.find(highlightedUnit.id).color(config.style.mouseOver)
      }

      this.unitmap.on('hitarea:click', (event) => {
        if (this.isFilteredUnit(event)) {
          const {units} = this.props

          let unit = units[event.hitarea.target().id]

          if (this.props.onUnitOver) {
            this.props.onUnitOver({
              unit: null,
              x: null,
              y: null
            })
          }

          if (this.props.onUnitClick) {
            trackEvent({
              category: 'Unit Map',
              action: 'Click',
              label: `Unit ${unit.id} / Unit Number ${unit.unitnumber}`
            })

            this.props.onUnitClick({
              unit: unit
            })
          }
        }
      })

      this.unitmap.on('hitarea:mouseover', (event) => {
        if (this.isFilteredUnit(event)) {
          const {
            config
          } = this.props
          event.hitarea.target().color(config.style.mouseOver)
        }
      })

      this.unitmap.on('hitarea:mousemove', (event) => {
        if (this.isFilteredUnit(event)) {
          if (this.props.onUnitOver) {
            const {
              units,
              style
            } = this.props

            let unit = units[event.hitarea.target().id]

            this.props.onUnitOver({
              unit: unit,
              x: event.originalEvent.clientX + config.tooltip.offset.x,
              y: event.originalEvent.clientY - config.tooltip.offset.y
            })
          }
        }
      })

      this.unitmap.on('hitarea:mouseout', (event) => {
        if (this.isFilteredUnit(event)) {
          const {
            config
          } = this.props

          event.hitarea.target().color(config.style.allCriteria)

          if (this.props.onUnitOver) {
            this.props.onUnitOver({
              unit: null,
              x: null,
              y: null
            })
          }
        }
      })
    }
  }

  componentDidUpdate(prevProps, previousState) {
    const {
      config,
      currentFloor,
      document,
      height,
      highlightedUnit,
      units,
      width,
    } = this.props

    if (document) {
      if (document !== prevProps.document) {
        this.unitmap.document(document.toJS())
      }

      // get all floors
      let floors = this.unitmap.select('levels').has({
        floor: true
      })

      floors.except({
        floor: currentFloor
      }).hide()

      floors.where({
        floor: currentFloor
      }).show()

      // get all units
      let all_units = this.unitmap.select('units')

      // set all units to unavailable
      all_units.color(config.style.noCriteria)

      // change color filtered units
      all_units.find(Object.keys(units)).color(config.style.allCriteria)

      if (highlightedUnit !== null) {
        all_units.find(highlightedUnit.id).color(config.style.mouseOver)
      }
    }
  }

  render() {
    const {
      backgroundColor,
      height,
      width
    } = this.props

    return (
    <div className="unit-map-panel" style={{width, height, backgroundColor}} ref="unitmap"></div>
    )
  }
}

UnitMapPanel.defaultProps = {
  width: '100%',
  height: '100%'
}

export default UnitMapPanel
